import ClosetLayout from "./ClosetLayout/ClosetLayout";

function PreviousClosets({ prevClosets, reloadPrevCloset }) {
  if (prevClosets.length === 0) return null;

  return (
    <>
      {prevClosets.map((prevCloset) => (
        <ClosetLayout
          key={prevCloset.id}
          closet={prevCloset}
          reloadCloset={() => reloadPrevCloset(prevCloset.id)}
        />
      ))}
    </>
  );
}

export default PreviousClosets;
